import { TitlePage } from '../../../TitlePage/TitlePage'
import { ButtonBasic, InputDinamycPlaceholder } from '@lk-gtcom/ecomlab-components';
import { ModalComponent } from '../../ModalComponent/ModalComponent';
import './ModalAddMenuItem.scss'

const ModalAddMenuItem = ({
    setIsModal,
    addNewItem,
    setNewItemLabel,
    newItemLabel,
    directory
}) => {

    return (
        <ModalComponent
            title={`Добавить ${directory ? 'папку' : 'раздел'}`}
            onClose={(e) => setIsModal(false)}
            style={{
                height: 'auto',
                maxWidth: '400px'
            }}
            child={
                <div className="modal-add-menu-item-v2">
                    <InputDinamycPlaceholder
                        onChange={(e) => setNewItemLabel(e)}
                        textErr='Неверное название'
                        placeholder='Введите название'
                        changeValue={newItemLabel}
                        size='s'
                    />

                    <div className="modal-add-menu-item-v2__btn-group">
                        <ButtonBasic
                            blue
                            width={'calc(50% - 6px)'}
                            text='Добавить'
                            onClick={addNewItem}
                        />

                        <ButtonBasic
                            grey
                            width={'calc(50% - 6px)'}
                            text='Отмена'
                            onClick={(e) => setIsModal(false)}
                        />
                    </div>
                </div>
            }
        />
    )
}

export { ModalAddMenuItem }